import './TheToolbarMenu.js';
import './TheToolbarMenuContentMobile.js';
import './types.js';
import menuIcon from '@/assets/images/menu.svg';
import { menu } from './menu.js';
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
:host {
  display: flex;
  justify-content: flex-end;
  --size: 30px;
  width: var(--size);
  height: var(--size);
}

:host(.opened) .menu {
  transform: translate(0);
}

.menu {
  width: 100dvw;
  height: 100dvh;
  position: sticky;
  z-index: 400;
  transform: translate(100%);
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: green;
}

.toggler {
  background-image: url(${menuIcon});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 20px;
  height: 100%;
  aspect-ratio: 1;
  border-radius: 6px;
  border-color: transparent;
  background-color: gray;
}
`);
export class TheToolbarMenu extends HTMLElement {
    static tag = 'the-toolbar-menu';
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [styleSheet];
    }
    attributeChangedCallback(name, oldVal, val) {
        this[name] = val;
    }
    connectedCallback() {
        this.shadowRoot.innerHTML = `
      <button class="toggler"></button>
    `;
        this.#createMenu(this.#menu);
    }
    /**
     * @type {Menu}
     * */
    #menu = menu;
    /**
     * @param {Menu} menu
     * */
    #createMenu(menu) {
        const $menuContentMobile = /** @type {TheToolbarMenuContentMobile} */ document.createElement('the-toolbar-menu-content-mobile');
        this.shadowRoot.querySelector('.toggler').addEventListener('click', () => $menuContentMobile.toggleShow());
        document.body.append($menuContentMobile);
    }
}
window.customElements.define(TheToolbarMenu.tag, TheToolbarMenu);
